import React, { useEffect } from 'react';
import FindTheLetterProvider from '../../../../../providers/FindTheLetterProvider';
import usePagingActivity from '../../../../../hooks/use-paging-activity';
import useGame from '../../../../../hooks/use-game';
import useTelemetry from '../../../../../hooks/use-telemetry';
import FindTheLetterDoublePage from './components/FindTheLetterDoublePage';
import FindTheLetterSinglePage from './components/FindTheLetterSinglePage';
import usePageViewAutoSwitch from '../../../../../hooks/use-page-view-auto-switch';
import { FindTheLetterInterface } from '../../../../../providers/GameProvider/types';
import { ActivityTypes, TelemetryEvents } from '../../../../../types';
import {
  ApplicationSection,
  PageLayout,
} from '../../../../../graph/schema-generated-types-educator';
import { formatCharacter, formatPageNumber } from '../../../../../util/telemetry-util';

const FindTheLetterActivity: React.FC = () => {
  const [, { fireEvent }] = useTelemetry(TelemetryEvents.ACCESS_ACTIVITY_PAGE);
  const [{ activityData, currentData }] = useGame<FindTheLetterInterface>();
  const { onePageBehavior, hasSecondPage } = usePagingActivity(
    currentData as FindTheLetterInterface[],
    activityData,
    'FindTheLetter'
  );

  usePageViewAutoSwitch();

  const singlePage = !hasSecondPage || onePageBehavior;

  useEffect(() => {
    const book = activityData?.book;
    const page = currentData?.[0]?.page;
    if (!book || !page) return;
    const character = { ...book.characters?.[0] };
    if (character) delete character.__typename;

    fireEvent({
      activityType: ActivityTypes.FIND_THE_LETTER,
      bookId: book.id,
      bookCode: book.bookCode,
      pageId: page.id,
      pageNumber: formatPageNumber(page.pageNumber),
      pageLayout: currentData?.length === 2 ? PageLayout.DOUBLE_PAGE : PageLayout.SINGLE_PAGE,
      section: ApplicationSection.LETTER_LEARNING,
      character: formatCharacter(character),
    });
  }, [currentData]);

  return (
    <FindTheLetterProvider>
      {singlePage ? <FindTheLetterSinglePage /> : <FindTheLetterDoublePage />}
    </FindTheLetterProvider>
  );
};

export default FindTheLetterActivity;
